/**
 * Shared confirm / destructive dialog shell — presentation only.
 *
 * Consumers (S1): ConfirmProvider (app), and any future controlled overlays.
 *
 * Contract:
 * - open/title/message/labels/variant are controlled by the caller.
 * - onCancel / onConfirm must not perform business mutations inside this shell.
 * - Markup, classes, focus-adjacent behavior match the historical ConfirmProvider dialog.
 * - Escape/backdrop dismiss is intentionally not added here (parity with prior overlay).
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Po',
  cancelLabel = 'Jo',
  variant = 'danger',
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" aria-modal="true" role="dialog">
      <div
        className="w-full max-w-md rounded-2xl border border-ops-line bg-ops-panel p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="mb-2 text-lg font-semibold text-ops-ink">{title}</h3>
        <p className="mb-6 text-sm text-ops-ink2">{message}</p>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-xl bg-ops-panel2 px-4 py-2.5 text-sm font-medium text-ops-ink2 transition hover:bg-ops-panel3"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`rounded-xl px-4 py-2.5 text-sm font-medium text-white transition ${variant === 'danger'
              ? 'bg-ops-alarm hover:opacity-90'
              : 'bg-ops-ok hover:opacity-90'
              }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
